import { motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

interface IProps {
  handleStop?: () => void
  handleHotLine?: () => void
  off?: () => void
}

export const TestConfirmStop = ({ handleStop = () => {}, off = () => {} }: IProps) => {
  return (
    <Container>
      <div className="confirm-stop">
        <div className="confirm-stop-center">
          <div className="stop-box">
            <div className="confirm-stop-title">停止检测</div>
            <div className="confirm-stop-text">设备检测尚未完成，现在退出可能会影响正常上课呦～</div>
            <div className="confirm-stop-btns">
              <div className="confirm-stop-btn confirm-stop-out anim_btn2" onClick={off}>
                退出
              </div>
              <div className="confirm-stop-btn anim_btn2" onClick={handleStop}>
                继续检测
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export const TestConfirmHotLine = ({ handleHotLine = () => {} }: IProps) => {
  return (
    <Container>
      <div className="confirm-stop">
        <div className="confirm-stop-center">
          <div className="stop-box">
            <div className="confirm-stop-title">电话热线</div>
            <div className="confirm-stop-hot">4000-888-799 转 2</div>
            <div className="confirm-stop-btns">
              <div className="confirm-stop-btn anim_btn2" onClick={handleHotLine}>
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

const Container = styled(motion.div)`
  // position: fixed;
  position: absolute;
  top: 0;
  left: 0;
  // width: 100vw;
  // height: 100vh;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.4); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  border-radius: 24px;
  .confirm-stop {
    width: 408px;
    // height: 180px;
    // padding: 5px;
    // background: rgba(255, 255, 255, 0.25);
    border-radius: 24px;
    color: #333;
    box-shadow: 0px 0px 0px 4px rgba(255, 255, 255, 0.25);
    &-center {
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 24px;
      .stop-box {
        // padding: 16px;
        padding: 1px;
      }
    }
    &-title {
      text-align: center;
      font-weight: 500;
      // margin-bottom: 20px;
      margin: 32px auto;
      font-size: 24px;
      padding: 0 30px;
    }
    &-text {
      // font-size: 15px;
      font-size: 16px;
      margin: 8px 25px;
      line-height: 1.6;
      // color: rgba(0, 0, 0, 1);
    }
    &-hot {
      color: #2893ff;
      text-align: center;
      font-size: 15px;
      line-height: 30px;
    }
    &-btns {
      // margin-top: 30px;
      // display: flex;
      // justify-content: space-around;
      // align-items: center;
      line-height: 48px;
      text-align: center;
      font-size: 18px;
      display: flex;
      justify-content: space-around;
      padding: 40px 25px 30px;
    }
    &-btn {
      width: 156px;
      height: 48px;
      background: #ff5050;
      box-shadow: 0px 4px 0px 0px #d1385f;
      border-radius: 20px;
      text-align: center;
      line-height: 48px;
      color: #fff;
      // font-size: 12px;
      border-radius: 25px;
      font-weight: 500;
    }
    &-out {
      // background: linear-gradient(180deg, rgba(189, 189, 189, 1) 0%, rgba(232, 232, 232, 1) 100%);
      // box-shadow: 0px 2px 0px 0px rgba(152, 152, 152, 1);
      background: #fff4f4;
      box-shadow: 0px 4px 0px 0px #fbe7e7;
      color: #f50500;
    }
  }
`
